import { createApp }   from 'vue'
import App             from './App'
import Loading         from './views/Loading'
import NotFound        from './views/404'

import router          from './router'
import store           from './store'
import api             from './api'

import Axios           from 'axios'
import { io }          from 'socket.io-client'
import VueSocketIOExt  from 'vue-socket.io-extended'
import VueMarkdownIt   from 'vue3-markdown-it'
import Vue3TouchEvents from "vue3-touch-events"
import smoothscroll    from 'smoothscroll-polyfill'

const

  map                  = `
                       ┌────────────┐
                       │meditation  │
                       │            │
                       │            │
                       │            │
          ┌────────────┼────────────┼────────────┐
          │ice         │audio map   │lecture     │
          │            │            │            │
          │            │            │            │
          │            │            │            │
          └────────────┼────────────┼────────────┘
                       │colophon    │
                       │            │
                       │            │
                       │            │
                       └────────────┘
        `,

  quadrants            = {
    map                : {},
    colophon           : {},
    meditation         : {},
    lecture            : {},
    ice                : {},
    notfound           : {},
  },

  markdownOptions      = {
    html               : true,
    linkify            : true,
    typographer        : true
  },

  globalProperties     = {
    $map               : map,
    $apiURL            : process.env.VUE_APP_API_URL,
    $baseURL           : process.env.VUE_APP_BASE_URL,
    $http              : Axios,
    $mdOpts            : markdownOptions,
  },

  createMyApp          = Comp => createApp(Comp),

  init                 = () => {

    let app = createMyApp(Loading)
    app.mount('#app')

    api
    .quadrants
    .getAll(quadrants)
    .then(quads => {

      store.commit('setQuadrants', quads)

      app = createMyApp(App)

      app.config.globalProperties = globalProperties
      app
      .use(VueSocketIOExt, io(globalProperties.$apiURL, { autoConnect: false }), { store })
      .use(VueMarkdownIt)
      .use(Vue3TouchEvents)
      .use(store)
      .use(router)
      .mount('#app')

      smoothscroll.polyfill()

    })
    .catch(error => {

      app = createMyApp(NotFound)
      app.config.globalProperties = globalProperties

      app
      .use(VueMarkdownIt)
      .mount('#app')

      console.error(error)
    })

  }

init()
